import React from "react";
// Common Main Card

import Typography from "@mui/material/Typography";
import Card from "@mui/material/Card";
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";

// Svg
import Calendar2 from "../../assets/svg/calendar2";
import Navigate from "../../assets/svg/navigate";
import Menu from "../../assets/svg/menu";

interface DashboardCardProps {
  title: string | React.ReactNode;
  className?: string;
  body?: React.ReactNode;
  link?: React.ReactNode;
  linkClick?: () => void;
  showIcons?: boolean;
  sx?: any;
  titleIcon?: React.ReactNode;
  action?: React.ReactNode;
}

const DashboardCard: React.FC<DashboardCardProps> = ({
  title,
  className,
  body,
  link,
  linkClick,
  showIcons = true,
  sx,
  titleIcon,
  action,
}) => {
  return (
    <Card className={`dashboard_card ${className}`} sx={sx}>
      <Stack
        direction={"row"}
        alignItems={"center"}
        px={2}
        justifyContent={"space-between"}
        py={0}
      >
        <Box>
          {typeof title === "string" ? (
            <Typography variant="h6" className="dashboard_card_title">
              {titleIcon}
              {title}
            </Typography>
          ) : (
            title
          )}
        </Box>

        <Stack direction={"row"} gap={"20px"} alignItems={"center"}>
          {action}
          {link && (
            <Box className="dashboard_card_link" onClick={linkClick}>
              {link}
            </Box>
          )}
          {showIcons && (
            <Stack direction={"row"} alignItems={"center"} gap={"17px"}>
              <Calendar2 fill="#A9A9A9" />
              <Navigate />
              <Menu />
            </Stack>
          )}
        </Stack>
      </Stack>
      {body}
    </Card>
  );
};

export default DashboardCard;
